
export class Scene1 extends Phaser.Scene {

  constructor() {
    super({
        key: "Scene1"
    });
  }

    preload(): void {

        this.load.image("factory", require("/src/assets/phaser-assets/textures/factory.png"));
  }

    create(): void {
        let im = this.add.image(200, 250, "factory");
        im.setOrigin(0);
        im.setDisplaySize(400, 400);
  }

  update(): void {
   
  }

}



// WEBPACK FOOTER //
// ./src/games/demos/phaserMultiSceneDemo/scenes/scene1.ts